import Reflux from "reflux";

const HeaderActions: any = Reflux.createActions(["updateHeader"]);
export default HeaderActions;
